const HTTP_PROTOCOL = /^https?:\/\//i;
const URL_SCHEME = /^[a-z][a-z\d+.-]*:/i;

export const isHttpUrl = (value: string): boolean => {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const isExternalUrl = isHttpUrl;

export const normalizeHttpUrl = (value: string): string => {
  const trimmedValue = value.trim();
  if (!trimmedValue || trimmedValue.startsWith("#")) return trimmedValue;
  if (HTTP_PROTOCOL.test(trimmedValue) || URL_SCHEME.test(trimmedValue)) {
    return trimmedValue;
  }
  if (trimmedValue.startsWith("//")) return `https:${trimmedValue}`;
  return `https://${trimmedValue}`;
};
